<section class="py-14 md:py-24">
  <!-- Header -->
  <div data-aos="fade-up">
    <span class="block text-[9px] leading-[15px] font-bold uppercase tracking-[2px] text-[#4A9EDB] mb-5">
      {{ 'talentSearchV2.talentPool.badge' | translate }}
    </span>

    <h2 class="text-[32px] md:text-[44px] lg:text-[52px] leading-[1.27] lg:leading-[66px] font-[900] tracking-[-2px] text-[#061430] mb-4"
        [innerHTML]="'talentSearchV2.talentPool.title' | translate | accent">
    </h2>

    <p class="text-[17px] leading-[30px] font-normal text-[#3B4A6B] max-w-[500px] mb-14">
      {{ 'talentSearchV2.talentPool.desc' | translate }}
    </p>
  </div>

  <!-- Two illustration images -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4" data-aos="fade-up" data-aos-delay="100">
    <app-responsive-img
      name="database-1"
      alt=""
      imgClass="w-full h-auto block select-none pointer-events-none rounded-2xl"
      sizes="(min-width: 768px) 50vw, 100vw"
    />

    <app-responsive-img
      name="database-2"
      alt=""
      imgClass="w-full h-auto block select-none pointer-events-none rounded-2xl"
      sizes="(min-width: 768px) 50vw, 100vw"
    />
  </div>

  <!-- Data points band -->
  <div class="data-band mt-[72px] rounded-[28px] p-8 md:p-12" data-aos="fade-up" data-aos-delay="200">
    <div class="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      <div *ngFor="let dp of dataPoints" class="flex flex-col gap-2.5">
        <span class="text-[22px] leading-none" *ngIf="!dp.icon.startsWith('svg:')">{{ dp.icon }}</span>
        <mat-icon *ngIf="dp.icon.startsWith('svg:')" [svgIcon]="dp.icon.slice(4)" class="!w-7 !h-5 block leading-none" />
        <p class="text-[13px] leading-[20px] font-bold text-white">
          {{ dp.titleKey | translate }}
        </p>
        <p class="text-[12px] leading-[18px] font-normal text-[#FFFFFF66]">
          {{ dp.descKey | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
